var map = {
	"./music-instructions.json": 3355,
	"./music-library-intro2024.json": 3356,
	"./music-library-launch2024.json": 3357,
	"./music-progression.json": 3358,
	"./startSourcesAdvanced.json": 3359,
	"./startSourcesSimple.json": 3360,
	"./startSourcesSimple2.json": 3361,
	"./startSourcesTracks.json": 3362
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3046;